<template>
  <v-toolbar card class="gradient_clair">
    <v-toolbar-title class="body-2 grey--text">
      <template v-if="oven">
        <span id="ovenName">{{ oven.name || oven.macAddress }}</span>
        &nbsp;
        <v-icon v-if="connected" color="green" size="18">fas fa-wifi</v-icon>
        <v-icon v-else color="orange" size="18">fas fa-wifi</v-icon>

        <template v-if="!connected && canReconnect">
          <v-btn class="ml-3 boutonRond" small color="orange" dark @click="reconnect()">Reconnecter</v-btn>
        </template>
      </template>
    </v-toolbar-title>

    <template v-if="connected">
      <v-spacer></v-spacer>

      <v-btn class="boutonRond" :disabled="!connected || heatingInProgress || readyLoading" v-if="ready" color="green"
        :loading="readyLoading" dark @click="changeState(0)">Prêt</v-btn>
      <v-btn class="boutonRond" :disabled="!connected || heatingInProgress || readyLoading" v-else color="orange"
        :loading="readyLoading" dark @click="changeState(1)">En veille</v-btn>

      <v-spacer></v-spacer>

      <v-btn-toggle v-model="modeEdit" mandatory>
        <v-btn large :disabled="!connected || modeEditLoading || !ready || heatingInProgress"
          :loading="modeEditLoading && mode == '2'" flat :color="mode2color('1')" :value="'1'" @click="changeMode('1')"
          class="pl-3 pr-3">
          <v-icon>icon-oven</v-icon>
        </v-btn>
        <v-btn large :disabled="!connected || modeEditLoading || !ready || heatingInProgress"
          :loading="modeEditLoading && mode == '1'" flat :color="mode2color('2')" :value="'2'" @click="changeMode('2')"
          class="pl-3 pr-3">
          <v-icon>icon-cloud</v-icon>
        </v-btn>
        <!-- bouton invisible, mode fumoir -->
        <v-btn v-show="false" :value="'3'">
          <v-icon>face</v-icon>
        </v-btn>
      </v-btn-toggle>
    </template>
  </v-toolbar>
</template>


<script>
export default {
  data() {
    return {
      modeEdit: null,
      modeEditLoading: false,
      // ready: false,
      readyLoading: false
    };
  },
  computed: {
    oven() {
      return this.$store.state.oven;
    },
    connected() {
      return this.$store.state.connected;
    },
    canReconnect() {
      return this.$store.state.canReconnect;
    },
    ovenData() {
      return this.$store.state.ovenData;
    },
    working() {
      return this.ovenData.working;
    },
    // chauffe en cours (boolean)
    heatingInProgress() {
      if (this.working == "1") {
        return true;
      }
      return false;
    },
    // en veille ou non
    state() {
      return this.ovenData.state;
    },
    // four (1) ou desidratateur (2)
    mode() {
      return this.ovenData.mode;
    },

    // veillle ou non (boolean)
    ready() {
      if (this.state == "1") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    // nouvel état (veile)
    changeState(newState) {
      // enpeche de reswitcher
      this.readyLoading = true;
      // requete de changement d'état
      this.$store
        .dispatch("pushState", newState)
        .then(res => {
          this.$store.commit("setState", newState + "");
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          // reactive le switch
          this.readyLoading = false;
        });
    },

    // change de mode
    changeMode(newMode) {
      // secu
      if (newMode === this.modeEdit) {
        return;
      }

      this.modeEditLoading = true;
      // requete de changement d'état
      this.$store
        .dispatch("pushMode", newMode)
        .then(res => {
          this.$store.commit("setMode", newMode + "");
        })
        .catch(err => {
          // remet le state comme avant changement
          this.modeEdit = this.mode;
        })
        .finally(() => {
          // reactive les boutons
          this.modeEditLoading = false;
        });
    },

    // couleur verte si mode choisi
    mode2color(modeOfButton) {
      if (this.mode == modeOfButton) {
        return "green";
      } else {
        return "gray";
      }
    },
    // reconnection
    reconnect() {
      this.$store.dispatch("reconnect");
    }
  },
  watch: {
    mode() {
      this.modeEdit = this.mode;
    }
  }
};
</script>

<style>

</style>
